// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailN":"N_d2xDetailN__SCWjq"};